import React, { useEffect, useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import { makeStyles } from "@mui/styles";
import CircularProgress from "@mui/material/CircularProgress";
import "./EmailVerification.css";
import { async } from "q";
import { apihandler } from "../Common/apicaller";
import { showNotificationMsz, verifyURL } from "../Common/comman";

const useStyles = makeStyles(() => ({
  backdrop: {
    zIndex: 1500,
    color: "#fff",
    // position: "absolute",
    width: "100%",
    minHeight: "100vh",
  },
}));

const EmailVerificationLink = (props) => {
  const classes = useStyles();
  const [messageShow, setMessageShow] = useState(false);
  const [messageData, seMessageData] = useState("");
  useEffect(() => {
    getEmailVerifcation();
  }, []);
  const getEmailVerifcation = async () => {
    try {
      const payload = {
        q: window.location.href,
      };
      const { data, status, message } = await apihandler(
        payload,
        verifyURL,
        "post"
      );
      if (status === 1) {
        // showNotificationMsz(message, "success");
        window.location = "/";
      } else {
        setMessageShow(true);
        seMessageData(message);
      }
    } catch (error) {
      console.log("email link Catch error", error);
    }
  };

  return (
    <div>
      {!messageShow ? (
        <Backdrop className={classes.backdrop} open style={props.style}>
          <div>
            <CircularProgress color="inherit" />
            <div className="emailVerifiyLink">Verifying email</div>
          </div>
        </Backdrop>
      ) : (
        <div className="emailMessage">{messageData}</div>
      )}
    </div>
  );
};

export default EmailVerificationLink;
